export const styles = (theme) => ({
    link: {
        color: "#009",
        margin: "0.5rem 0",
        fontFamily: "newsGothic_demi,Arial,Verdana,Helvetica,sans-serif",
        fontWeight: 600,
        "&:hover": {
            textDecoration: "underline",
        },
        cursor: "pointer"
    }
});
